import React from 'react';

import { ClickAwayListener, Popper } from '@material-ui/core';
import usePopupState from 'components/hooks/usePopupState';
import styled from 'styled-components';

import { onPopupClickAwayWrapper } from './helper';

export default function EmployeeEditPopup({ id, anchorEl, setAnchor, children, popperProps = {} }) {
  const { open, newId } = usePopupState({ id, anchorEl });
  const handleClickAway = onPopupClickAwayWrapper(anchorEl, setAnchor);
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <StyledPopper id={newId} open={open} anchorEl={anchorEl} placement="bottom" {...popperProps}>
        {children}
      </StyledPopper>
    </ClickAwayListener>
  );
}

const StyledPopper = styled(Popper)`
  z-index: 1201;
  min-width: 240px;
  max-width: 420px;
`;
